import { render, staticRenderFns } from "./ForgotPasswordEmailForm.vue?vue&type=template&id=f85b2b74"
import script from "./ForgotPasswordEmailForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports